const React = require("react");
const T = require("prop-types");
const Paper = require("material-ui/Paper").default;
const RaisedButton = require("material-ui/RaisedButton").default;
const TextField = require("material-ui/TextField").default;
const Checkbox = require("material-ui/Checkbox").default;
const IsEmail = require("utils/is-email");
const NavLink = require("react-router-dom").NavLink;

const internals = {};

internals.paperStyle = {
    padding: "3rem",
    margin: "4rem 0"
};

internals.labelStyle = {
    textTransform: "inherit"
};

module.exports = class CreateAccount extends React.Component {
    static propTypes = {
        location: T.object.isRequired,
        onSubmit: T.func.isRequired
    };

    constructor() {
        super();

        this.state = {
            isCheckedTOS: false,
            firstName: "",
            lastName: "",
            confirmNameHasBlurred: false,
            email: "",
            confirmEmailHasBlurred: false,
            password: "",
            confirmPassword: "",
            confirmPasswordHasBlurred: false
        };

        this.nameChanged = this._nameChanged.bind(this);
        this.confirmNameBlurred = this._confirmNameBlurred.bind(this);
        this.emailChanged = this._emailChanged.bind(this);
        this.confirmEmailBlurred = this._confirmEmailBlurred.bind(this);
        this.passwordChanged = this._passwordChanged.bind(this);
        this.confirmPasswordBlurred = this._confirmPasswordBlurred.bind(this);
        this.confirmPasswordChanged = this._confirmPasswordChanged.bind(this);
        this.checkedTosChanged = this._checkedTosChanged.bind(this);
        this.submit = this._submit.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    _nameChanged(ev) {
        if (ev.target.id === "firstName") {
            this.setState({ firstName: ev.target.value });
        }

        if (ev.target.id === "lastName") {
            this.setState({ lastName: ev.target.value });
        }
    }

    _confirmNameBlurred() {
        this.setState({ confirmNameHasBlurred: true });
    }

    _emailChanged(ev, value) {
        this.setState({ email: value });
    }

    _confirmEmailBlurred() {
        this.setState({ confirmEmailHasBlurred: true });
    }

    _passwordChanged(ev, value) {
        this.setState({ password: value });
    }

    _confirmPasswordBlurred() {
        if (!this.state.confirmPasswordHasBlurred) {
            this.setState({ confirmPasswordHasBlurred: true });
        }
    }

    _confirmPasswordChanged(ev, value) {
        this.setState({ confirmPassword: value });
    }

    _submit(ev) {
        const { email, firstName, lastName, password } = this.state;

        this.props.onSubmit(
            email,
            firstName,
            lastName,
            password,
            this.props.location.state
                ? this.props.location.state.redirect
                : null
        );
        ev.preventDefault();
    }

    _checkedTosChanged(event, checked) {
        this.setState({ isCheckedTOS: checked });
    }

    render() {
        const {
            isCheckedTOS,
            firstName,
            lastName,
            confirmNameHasBlurred,
            email,
            confirmEmailHasBlurred,
            password,
            confirmPassword,
            confirmPasswordHasBlurred
        } = this.state;

        const emailError =
            confirmEmailHasBlurred && (email === "" || !IsEmail(email));
        const passwordsMatch = password === confirmPassword;
        const passwordEmpty =
            confirmPasswordHasBlurred && confirmPassword.length === 0;
        const passwordError =
            confirmPasswordHasBlurred &&
            (password || confirmPassword) &&
            !passwordsMatch;
        const nameEmpty = (firstName && lastName).length === 0;
        const nameError = confirmNameHasBlurred && nameEmpty;

        const isButtonDisabled = !(
            !nameEmpty &&
            IsEmail(email) &&
            passwordsMatch &&
            !passwordEmpty &&
            isCheckedTOS
        );

        return (
            <Paper style={internals.paperStyle}>
                <h1>Welcome to MyBodyModel!</h1>
                <p>Please create an account to get started.</p>
                <form onSubmit={this.submit}>
                    <div className="form-group">
                        <TextField
                            floatingLabelText="First Name"
                            value={firstName}
                            id="firstName"
                            onChange={this.nameChanged}
                            pattern="[a-z,A-Z]"
                        />
                    </div>
                    <div className="form-group">
                        <TextField
                            floatingLabelText="Last Name"
                            value={lastName}
                            id="lastName"
                            onChange={this.nameChanged}
                            onBlur={this.confirmNameBlurred}
                            errorText={
                                nameError &&
                                "Please enter a first and last name"
                            }
                        />
                    </div>
                    <div className="form-group">
                        <TextField
                            type="email"
                            floatingLabelText="Email Address"
                            value={email}
                            onChange={this.emailChanged}
                            onBlur={this.confirmEmailBlurred}
                            errorText={emailError && "Please enter your email"}
                        />
                    </div>
                    <div className="form-group">
                        <TextField
                            type="password"
                            floatingLabelText="Password"
                            value={password}
                            onChange={this.passwordChanged}
                        />
                    </div>
                    <div className="form-group">
                        <TextField
                            type="password"
                            floatingLabelText="Confirm Password"
                            onBlur={this.confirmPasswordBlurred}
                            onChange={this.confirmPasswordChanged}
                            value={confirmPassword}
                            errorText={
                                (passwordError && "Password does not match") ||
                                (passwordEmpty && "Please provide a password")
                            }
                        />
                    </div>
                    <div>
                        <Checkbox
                            label={
                                <span>
                                    I understand and agree to the MyBodyModel{" "}
                                    <a
                                        href="http://mybodymodel.com/termsofuse"
                                        target="_blank"
                                    >
                                        Terms of Use
                                    </a>{" "}
                                    and{" "}
                                    <a
                                        href="http://mybodymodel.com/privacypolicy"
                                        target="_blank"
                                    >
                                        Privacy Policy
                                    </a>
                                </span>
                            }
                            labelStyle={{
                                zIndex: 9
                            }}
                            checked={this.state.isCheckedTOS}
                            onCheck={this.checkedTosChanged}
                        />
                    </div>
                    <RaisedButton
                        primary
                        label="Create Account"
                        labelStyle={internals.labelStyle}
                        disabled={isButtonDisabled}
                        onClick={this.submit}
                        type="submit"
                        style={{ marginTop: "15px" }}
                    />
                </form>
                <div className="form-subnote">
                    Have an account? <NavLink to="/login">Log in</NavLink>
                </div>
            </Paper>
        );
    }
};



// WEBPACK FOOTER //
// ./src/routes/create-account/components/CreateAccount.js